class CheckAllStore {
  constructor(key) {
    this.key = key
    this.storage = {}
    this.storage[this.key] = []
  }

  list = () => {
    return this.storage[this.key]
  }

  push = (value) => {
    this.storage[this.key].indexOf(value) === -1 ? this.storage[this.key].push(value) : console.log('This item already exists')
  }

  pop = (value) => {
    const index = this.storage[this.key].indexOf(value)
    if (index > -1) {
      this.storage[this.key].splice(index, 1)
    }
  }

  clear = () => {
    this.storage[this.key] = []
  }
}

class CheckAllSessionStore {
  constructor(key) {
    this.key = key
    this.storage = sessionStorage
  }

  list = () => {
    return JSON.parse(this.storage.getItem(this.key) || '[]')
  }

  clear = () => {
    this.storage.removeItem(this.key)
  }

  push = (value) => {
    this.list().indexOf(value) === -1 ? this.storage.setItem(this.key, JSON.stringify(this.list().concat(value))) : console.log('This item already exists')
  }

  pop = (value) => {
    this.storage.setItem(this.key, JSON.stringify(this.list().filter(function(item) { return item !== value })))
  }
}

export const useCheckAll = (controller, persist = false, scope = 'default') => {
  Object.assign(controller, {
    initUseCheckAllData() {
      controller.useCheckAll = {
        state: {
          checkboxesChecked: persist ? new CheckAllSessionStore('checkboxesChecked_' + scope) : new CheckAllStore('checkboxesChecked'),
          checkboxesUnchecked: persist ? new CheckAllSessionStore('checkboxesUnchecked_' + scope) : new CheckAllStore('checkboxesUnchecked'),
          isAllChecked: true
        },
        options: {
          checkboxToCheckTargetName: 'checkbox',
          checkboxToCheckAllTargetName: 'checkAll',
          checkboxesCheckedCounterTargetName: 'checkboxesCheckedCounter',
          checkboxesCheckedCounterValueName: 'checkboxesChecked',
          checkboxesCheckedCounterValueNameCapitalized: 'CheckboxesChecked'
        }

      }
    },

    initCheckboxesCheckedValueChangedMethod() {
      const valueChangedMethodName = `${controller.useCheckAll.options.checkboxesCheckedCounterValueName}ValueChanged`
      if (controller[valueChangedMethodName] === undefined) {
        controller[valueChangedMethodName] = () => {
          controller.getCheckboxCheckedCounter().innerHTML = controller.getCheckboxesCheckedAmount()
        }
      }
    },

    pushCheckboxesChecked(checkbox) {
      return controller.useCheckAll.state.checkboxesChecked.push(checkbox.dataset.referenceId)
    },
    pushCheckboxesUnchecked(checkbox) {
      return controller.useCheckAll.state.checkboxesUnchecked.push(checkbox.dataset.referenceId)
    },
    popCheckboxesChecked(checkbox) {
      return controller.useCheckAll.state.checkboxesChecked.pop(checkbox.dataset.referenceId)
    },
    popCheckboxesUnchecked(checkbox) {
      return controller.useCheckAll.state.checkboxesUnchecked.pop(checkbox.dataset.referenceId)
    },
    getReferenceIds() {
      return controller.useCheckAll.state.checkboxesChecked.list()
    },
    getCheckboxesChecked() {
      return $.map(controller.getReferenceIds(), function(i) {
        return document.querySelector(`[data-reference-id="${i}"]`)
      })
    },

    getCheckboxesUnchecked() {
      return controller.useCheckAll.state.checkboxesUnchecked.list()
    },

    getIsAllChecked() {
      return controller.useCheckAll.state.isAllChecked
    },

    getCheckboxesToCheck() {
      return controller[`${controller.useCheckAll.options.checkboxToCheckTargetName}Targets`]
    },

    getCheckboxToCheckAll() {
      return controller[`${controller.useCheckAll.options.checkboxToCheckAllTargetName}Target`]
    },

    getCheckboxCheckedCounter() {
      return controller[`${controller.useCheckAll.options.checkboxesCheckedCounterTargetName}Target`]
    },

    getCheckboxesToCheckAmount() {
      return controller.getCheckboxesToCheck().length
    },

    getCheckboxesCheckedAmount() {
      return controller.useCheckAll.state.checkboxesChecked.list().length
    },

    getCheckboxesUncheckedAmount() {
      return controller.getCheckboxesUnchecked().length
    },

    setCheckboxesChecked(value) {
      controller.useCheckAll.state.checkboxesChecked = value
    },

    setCheckboxesUnchecked(value) {
      controller.useCheckAll.state.checkboxesUnchecked = value
    },

    setIsAllChecked(value) {
      controller.useCheckAll.state.isAllChecked = value
    },

    setCheckboxesCheckedCounterValue(value) {
      const methodName = `${controller.useCheckAll.options.checkboxesCheckedCounterValueName}Value`
      controller[methodName] = controller.getCheckboxesCheckedAmount()
    },

    setAllCheckboxesWithChecked(checked) {
      const checkboxesToSelect = controller.getCheckboxesToCheck()
      checkboxesToSelect.forEach((checkbox) => {
        checkbox.checked = checked
        if (checked) {
          controller.pushCheckboxesChecked(checkbox)
          controller.popCheckboxesUnchecked(checkbox)
        } else {
          controller.popCheckboxesChecked(checkbox)
          controller.pushCheckboxesUnchecked(checkbox)
        }
      })

      controller.setIsAllChecked(checked)
      controller.updateCheckboxToCheckAllChecked(checked)
      controller.refreshCheckboxesCheckedCounter()
    },

    hasCheckboxesCheckedCounterValue() {
      const hasValueMethodName = `has${controller.useCheckAll.options.checkboxesCheckedCounterValueNameCapitalized}Value`
      return controller[hasValueMethodName]
    },

    refreshCheckboxesCheckedCounter() {
      if (controller.hasCheckboxesCheckedCounterValue()) {
        controller.setCheckboxesCheckedCounterValue(controller.getCheckboxesCheckedAmount())
      } else if (controller.getCheckboxCheckedCounter()) {
        controller.getCheckboxCheckedCounter().innerHTML = controller.getCheckboxesCheckedAmount()
      }

      if (typeof controller.updateExportButtonLabel === 'function') {
        if (controller.getReferenceIds().length === 0) {
          controller.updateExportButtonLabel(this.data.get('count'))
        } else {
          controller.updateExportButtonLabel(controller.getReferenceIds().length)
        }
      }

      if (typeof controller.updateReportButtonLabel === 'function') {
        if (controller.getReferenceIds().length === 0) {
          controller.updateReportButtonLabel(this.data.get('count'))
        } else {
          controller.updateReportButtonLabel(controller.getReferenceIds().length)
        }
      }
    },

    reinitCheckboxesStateLists() {
      controller.setCheckboxesChecked(persist ? new CheckAllSessionStore('checkboxesChecked') : new CheckAllStore('checkboxesChecked'))
      controller.setCheckboxesUnchecked(persist ? new CheckAllSessionStore('checkboxesUnchecked') : new CheckAllStore('checkboxesUnchecked'))
    },

    updateCheckboxesStateLists() {
      controller.getCheckboxesToCheck().forEach((checkbox) => {
        if (checkbox.checked) {
          controller.pushCheckboxesChecked(checkbox)
          controller.pushCheckboxesUnchecked(checkbox)
        } else {
          controller.popCheckboxesChecked(checkbox)
          controller.pushCheckboxesUnchecked(checkbox)
        }
      })
    },

    toggleAllCheckboxes() {
      const isAllChecked = controller.getIsAllChecked()
      controller.setAllCheckboxesWithChecked(!isAllChecked)

      if (isAllChecked) {
        controller.useCheckAll.state.checkboxesChecked.clear()
        controller.refreshCheckboxesCheckedCounter()
      }
    },

    uncheckAll() {
      controller.setAllCheckboxesWithChecked(false)
      controller.useCheckAll.state.checkboxesChecked.clear()
      controller.useCheckAll.state.checkboxesUnchecked.clear()
      controller.refreshCheckboxesCheckedCounter()
    },

    checkAll() {
      controller.setAllCheckboxesWithChecked(true)
    },

    updateCheckboxToCheckAllChecked(value) {
      if (controller.getCheckboxToCheckAll()) { controller.getCheckboxToCheckAll().checked = value }
    },

    preselectCheckboxes() {
      controller.getCheckboxesChecked().forEach(checkbox => { checkbox.checked = true })
    },

    /*
     * This method is called when controller connects as well as
     * when checkbox is checked/unchecked, for example:
     *  change->entity-select#updateCheckboxesChecked
    */
    updateCheckboxesChecked(event) {
      if (event) {
        if (event.target.checked) {
          controller.pushCheckboxesChecked(event.target)
        } else {
          controller.popCheckboxesChecked(event.target)
        }

        if (controller.getCheckboxesCheckedAmount() > 0 && controller.getCheckboxesToCheck().length === controller.getCheckboxesCheckedAmount()) {
          controller.setIsAllChecked(true)
        } else {
          controller.setIsAllChecked(false)
        }
        controller.updateCheckboxToCheckAllChecked(controller.getIsAllChecked())
        controller.refreshCheckboxesCheckedCounter()
      } else {
        controller.updateCheckboxesStateLists()
        if (controller.getCheckboxesCheckedAmount() > 0 && controller.getCheckboxesToCheck().length === controller.getCheckboxesCheckedAmount()) {
          controller.setIsAllChecked(true)
        } else {
          controller.setIsAllChecked(false)
        }
      }
    },

    refreshAllChecked() {
      controller.getCheckboxesToCheck().forEach((checkbox) => {
        if (!checkbox.checked) {
          controller.setIsAllChecked(false)
        }
      })
    },

    initState() {
      controller.preselectCheckboxes()
      controller.refreshCheckboxesCheckedCounter()
      controller.refreshAllChecked()
      controller.initCheckboxesCheckedValueChangedMethod()
    },

    initializeMixin() {
      controller.initUseCheckAllData()
      this.initState()
    }
  })
  controller.initializeMixin()
}
